import { useMemo } from 'react';
import type { GlobalShortcutsItem } from '@atlassian/global-shortcuts/types';
import type { MenuItemConfigData } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export type GlobalShortcutsItemMap = {
	[key: string]: GlobalShortcutsItem;
};
export const useOrderedAppShortcuts = (
	shortcuts: GlobalShortcutsItemMap,
	appItemsData?: MenuItemConfigData[],
): GlobalShortcutsItem[] => {
	const orderedShortcuts = useMemo(() => {
		// Under `navx-4531-gas-customisation-fix`, an empty `appItemsData` is a meaningful
		// state ("upstream filtered everything out") and must not fall back to the full
		// shortcuts map — doing so would bypass the licence + permission checks performed
		// upstream by getAppItemsData. Only fall back when `appItemsData` is undefined
		// (caller didn't pass it at all).
		if (fg('navx-4531-gas-customisation-fix')) {
			if (!appItemsData) {
				return Object.values(shortcuts);
			}
		} else if (!appItemsData || appItemsData.length === 0) {
			return Object.values(shortcuts);
		}

		return appItemsData.reduce<GlobalShortcutsItem[]>((acc, value) => {
			const config = shortcuts[value.menuId];
			if (config && value.visible) {
				acc.push(config);
			}
			return acc;
		}, []);
	}, [appItemsData, shortcuts]);
	return orderedShortcuts;
};
